define('constants/userProfileConstants',[], function() {
   return {
       noFileTooltip:  "Click to Upload",
       fileSelectedTooltip: "Click to Change",
       maxContactPhoneNumbers: 5
   };
});

